module.exports = __webpack_public_path__ + "media/images/history/kojdecky2-3aa20a25b881c0a91c66f5098e4668b8.jpg";